import React from 'react';
import { Card, Descriptions } from 'antd';
import PropTypes from 'prop-types';
import { CurrencyDisplay } from '../../../../layout';
import DateDisplay from '../../../../layout/DateDisplay';
import { ENUM_APPLICATION_STATUS } from 'constants/form';

const ConfirmVirementDetail = ({ data, title, confirm }) => {
  const virement = data.virements[0];

  return (
    <Card title={title}>
      <Descriptions>
        {!confirm && (
          <>
            <Descriptions.Item label="Virement Request Date" span={1}>
              <DateDisplay date={virement.date} />
            </Descriptions.Item>
            <Descriptions.Item label="Status" span={2}>
              {ENUM_APPLICATION_STATUS[virement.status]}
            </Descriptions.Item>
          </>
        )}
        <Descriptions.Item label="From Budget Category" span={3}>
          {virement.fromBudget?.budgetCategory.name}
        </Descriptions.Item>
        <Descriptions.Item label="To Budget Category" span={3}>
          {virement.toBudget?.budgetCategory.name}
        </Descriptions.Item>
        <Descriptions.Item label="Virement Amount" span={3}>
          <CurrencyDisplay amount={virement.amount} />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

ConfirmVirementDetail.defaultProps = {
  data: {
    virements: [],
  },
  title: 'Virement Details',
  confirm: false,
};

ConfirmVirementDetail.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  confirm: PropTypes.bool.isRequired,
};

export default ConfirmVirementDetail;
